import { Container, styled } from "@mui/material";

export const MuiContainer = styled(Container)`
    padding-bottom: 1.875rem;
    height: calc(100% - 173px);
`;

export const Form = styled('form')`
    height: 100%;
`;